import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { motion } from "framer-motion";

import { jobs } from "../careerData";
import JobBanner from "./JobBanner";
import JobOverview from "./JobOverView";
import Benefits from "./Benefits";
import HiringProcess from "./HiringProcess";
import ApplyCTA from "./ApplyCTA";
import JobApplicationModal from "../JobApplicationModal";
import RoleDetails from "./RoleDetails";

const JobDetails = () => {
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);

  const job = jobs.find((item) => item.id.toString() === id);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  if (!job) {
    return <Navigate to="/career" replace />;
  }

  return (
    <main className="relative overflow-hidden theme-bg-primary theme-text-primary font-saira">
      {/* ================= Banner ================= */}
      <JobBanner
        job={job}
        onApply={() => setShowModal(true)}
      />

      {/* ================= Main Content ================= */}
      <section className="relative py-16 lg:py-24">
        {/* Background Glow */}
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <motion.div
            animate={{
              scale: [1, 1.15, 1],
              opacity: [0.08, 0.18, 0.08],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
            }}
            className="absolute left-1/2 top-0 h-[600px] w-[600px] -translate-x-1/2 rounded-full blur-[180px]"
            style={{
              backgroundColor: "var(--brand-primary)",
            }}
          />
        </div>

        {/* Content */}
        <div className="relative mx-auto max-w-7xl space-y-20 px-4 sm:px-6 lg:px-8">
          <JobOverview job={job} />

          <RoleDetails job={job} />

          <Benefits job={job} />

          <HiringProcess />
        </div>
      </section>

      {/* ================= CTA ================= */}
      <ApplyCTA
        job={job}
        onApply={() => setShowModal(true)}
      />

      {/* ================= Application Modal ================= */}
      <JobApplicationModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        job={job}
      />
    </main>
  );
};

export default JobDetails;